import { render, staticRenderFns } from "./View.vue?vue&type=template&id=635c1db3&scoped=true"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"
import style0 from "./View.vue?vue&type=style&index=0&id=635c1db3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635c1db3",
  null
  
)

export default component.exports